<div class="plans-body">
  <div *ngFor="let plan of plans">

    <div style="margin-top: 15px;">
      <div class="card-image" routerLink="/general/planDetail/{{ plan.Id }}">
        
        <div class="card-footer">
          <h4 class="card-title title-tlh4-1">{{ plan.EstabelecimentoNome }}</h4>
        </div>
        
        <div class="card-footer marginTop167">
          <h4 class="card-title title-tlh4-1">{{ plan.Nome }}</h4>
        </div>

        <img [src]="plan.Image.url">
        <div class="card-footer ">
          <h4 class="card-title title-bold">{{ plan.Nome }} <span style="float: right;"> <span style="font-weight: 400; font-size: 12px;">
                  R$</span> {{ plan.ValorTotal.toFixed(2).toString().split('.')[0] }},{{ plan.ValorTotal.toFixed(2).toString().split('.')[1] }}</span></h4>
        </div>
        
      </div>
    </div>
  </div>

  <mat-list-item *ngIf="!plans || plans.length == 0">
      <div class="lista-cartao-ativar">
        <ul class="margin-25px">
          <li>
            <div style="text-align: center;">
              <img src="assets/images/no-plan.png">
            </div>
          </li>
        </ul>
      </div>
    </mat-list-item>

    <button (click)="goToDependents()" class="confirma">
      Meus Planos
    </button>
    <div class="backgroundTrasparente"></div>

</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/plan/plan.component.html